import React, { Component } from 'react';
import { Card, Col, Collapse, Icon, Popover } from 'antd';
import './style.css';
import Header from '../../Home/components/Header';
import TopBG from '../../../image/home/top-bg@3x.png';

const Panel = Collapse.Panel;

class PricingIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      pricingType: 'essentials',
      mobView: false,
    };
    this.collapse = this.collapse.bind(this);
  }

  componentDidMount() {
    if (window.innerWidth < 786) {
      this.setState({
        mobView: true,
      });
    }
  }

  collapse(key) {
    this.setState({
      collapse: !!key.length,
    });
  }

  changePricingType(e) {
    this.setState({
      pricingType: e.target.value,
    });
  }

  render() {
    const { collapse, pricingType, mobView } = this.state;
    const customPanelStyle = {
      background: '#fff',
      borderRadius: 4,
      marginBottom: 24,
      border: 0,
      overflow: 'hidden',
    };
    return (
      <div className="pricing">
        <div className='bt_portal-home'>
          <img
            src={TopBG}
            className='home-bg-img'/>
          <div className='landing_section centered-content'>
            <Header {...this.props} isLoginVisible/>
          </div>
        </div>
        {/*<div className="pricing-back-flex" />*/}
        <div className="pricing-content-flex">
          <div className="pricing-container">
            <h1 className="pricing-title base-text">
              Pricing Guide
            </h1>
            <p className="pricing-sub-title para-text">
              Leverage the only multi-modality evidence-based behavioral health platform to engage with your clients
            </p>
          </div>
          <div className='upgrade-plan-page' style={{ background: 'transparent' }}>
            <div className="plan-container">
              <div className='plan-list'>
                <Card className='plan-card' style={{ minHeight: '100%' }}>
                  <div className='ribbon ribbon-top-right ribbon-blue'><span>Basic</span></div>
                  <div className='basic-plan-header font-family-extra-bold'>
                    <h3 className='bold-text'>$<span className='plan-amount'>0</span></h3>
                    <div className='bold-text primary-text base-text' style={{ fontSize: 40 }}>FREE</div>
                  </div>
                  <div className='basic-plan-feature disabled-text base-text'>
                    Signup for basic plan to <strong>securely</strong> view your clients' diary entries, exercises. By
                    having a real-time view of your clients' behavioral health data you can better tailor your
                    treatment.
                  </div>

                </Card>
                <Card className='plan-card' style={{ minHeight: '100%' }}>
                  <div className='ribbon ribbon-top-right ribbon-purple base-text'><span>Premium</span></div>
                  <div className='other-plan-container font-family-extra-bold'>
                    <h3 className='bold-text'>$<span className='plan-amount'>{20}{' '}</span></h3>
                    <div className='bold-text secondary-text base-text' style={{ fontSize: 40 }}> &nbsp;MONTHLY</div>
                  </div>
                  <div className='basic-plan-feature disabled-text base-text'>
                    In addition to all basic plan features, you can better engage with clients by assigning homework -
                    exercises, lessons and practice ideas. Further, you can assign standardized assessments (PHQ-9,
                    GAD-7 etc.) and measure outcome.
                  </div>
                </Card>
                <Card className='plan-card' style={{ minHeight: '100%' }}>
                  <div className='ribbon ribbon-top-right ribbon-green base-text'><span>Professional</span></div>
                  <div className='other-plan-container font-family-extra-bold'>
                    <h3 className='bold-text'>$<span className='plan-amount'>{40}{' '}</span></h3>
                    <div className='bold-text success-text base-text' style={{ fontSize: 40 }}> &nbsp;MONTHLY</div>
                  </div>
                  <div className='basic-plan-feature padding-bottom-four disabled-text base-text'>
                    In addition to all premium features, you can have access to a complete EHR for Behavioral Health.
                    Make appointments, secure messages, secure video calls, notes and billing,
                  </div>

                </Card>
              </div>
            </div>
          </div>

          <div className="pricing-app-container">

            <div className='pricing-app-container-content'>
              <h4 className="primary-text title base-text">TELE HEALTH</h4>
              <div className='pricing-inner-box'>
                <Col md={12}>
                  <h4 className='primary-text base-text'>$<span className='bold-text font-value'>8</span><span> / MONTH PER CLINICIAN</span>
                  </h4>
                  {/*<div className='secondary-text'>FREE 30-DAY TRIAL</div>*/}
                  <div className='margin-top-one margin-bottom-one base-text'>The secure, stress, free, fully integrated
                    solution for video appointments with your clients
                  </div>
                </Col>
                {/* <Col md={12}>
                  <Button className='primary-text align-text' onClick={()=>this.props.history.push('/signin')}> Start Free Trial </Button>
                </Col>*/}
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content blank-box"/>
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-title bold-text base-text">
                  Essentials
                </h1>
              </div>
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-title bold-text base-text">
                  Premium
                </h1>
              </div>
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-title bold-text base-text">
                  Professional
                </h1>
              </div>
            </div>
            <div className="pricing-app-content-box full-width-content-box">
              <div className="pricing-app-content-col">
                <h1 className="pricing-app-content-sub-title secondary-text base-text">
                  Discovery
                </h1>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Get Listed
                  <Popover placement="right" title={''}
                           content={'Manage your profile and then get discovered by users of Resiliens\'s apps such as DBT Coach, ACT Coach, CBT Companion etc. in your area.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Intelligent matching
                  <Popover placement="right" title={''}
                           content={'Get discovered by our Find Provider tool. We recommend you to clients who match your expertise and availability.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Preferred Listing
                  <Popover placement="right" title={''}
                           content={'Get listed on top of search results. Also indicates to users that you are using the clinician app that integrates with all our client facing apps.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>


            <div className="pricing-app-content-box full-width-content-box">
              <div className="pricing-app-content-col">
                <h1 className="pricing-app-content-sub-title secondary-text base-text">
                  Client Engagement
                </h1>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Evidence Based Therapy Apps
                  <Popover placement="right" title={''}
                           content={' Access our Evidence Based Therapy Apps for each of the treatment modalitites such as DBT, CBT, ACT, EMDR, IFS, MBCT etc.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>
            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  View Clients' Health Data
                  <Popover placement="right" title={''}
                           content={'Access your clients\' behavioral health data in real-time - such as diary entries, homework, exercises, meditations, practice ideas etc. '}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>
            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Assign Homework
                  <Popover placement="right" title={''}
                           content={'Assign therapy specific homework - lessons, exercises, practice ideas, meditations, activities and let the clients submit all through the app. The platform automatically sends notifications via email and mobile push notifications.'}
                           trigger="click" innerWidth="600px">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>
            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Standardized Assessments
                  <Popover placement="right" title={''}
                           content={'Assign clinical assessments such as PHQ-9, GAD-7 etc. and score them periodically so you can track clients\' progress and adjust treatment accordingly.'}
                           trigger="click" innerWidth="600px">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>
            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Video Tele-Therapy
                  <Popover placement="right" title={''}
                           content={'Schedule remote consultations with your clients when they can\'t see you physically using our secure video conferencing tools.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Secure Chat
                  <Popover placement="right" title={''}
                           content={'Send and receive secure messages with your clients between sessions. Helps you better engage in their progress.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>


            <div className="pricing-app-content-box full-width-content-box">
              <div className="pricing-app-content-col">
                <h1 className="pricing-app-content-sub-title secondary-text base-text">
                  Practice Management
                </h1>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  HIPAA Compliant
                  <Popover placement="right" title={''}
                           content={'Resiliens\'s secure platform across all its apps maintains all necessary security standards to meet HIPAA compliance requirements'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Schedule Appointments
                  <Popover placement="right" title={''}
                           content={'Manage your schedule with easy appointment scheduling, for both in-person and teletherapy appointments.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Notes and Documentation
                  <Popover placement="right" title={''}
                           content={'Streamline your workflow with structured notes, specialized templates, and reusable forms. Store all of your business and client documents securely with full HIPAA compliance.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Client Billing
                  <Popover placement="right" title={''}
                           content={'Keep your finances under control with integrated credit card processing, automated bookkeeping, easy invoicing, and client self-service.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Insurance Billing
                  <Popover placement="right" title={''}
                           content={'Claim filing is quick, simple, and more secure with easy enrollments, auto-populated claims, status tracking, and integrated ERAs.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>
            <div className="pricing-app-content-box">
              <div className="pricing-app-content-col colored-pricing-app-content">
                <h1 className="pricing-app-content-sub-title base-text">
                  Client Portal
                  <Popover placement="right" title={''}
                           content={'Clients can fill out intakes, request appointments, send messages, download & upload documents, and pay bills from a secure, easy-to-use portal.'}
                           trigger="click">
                    <Icon type="info-circle" className="pricing-app-content-sub-title_info-icon"/>
                  </Popover>
                </h1>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'close'} className="pricing-app-content-close-icon"/>
              </div>
              <div className="pricing-app-content-col check-col">
                <Icon type={'check'} className="pricing-app-content-check-icon"/>
              </div>
            </div>

            {/* <div className="pricing-app-content-box full-width-content-box">
              <div className="pricing-app-content-col" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <h1 className="pricing-app-content-sub-title secondary-text">
                    Tele Health
                  </h1>
                  <p style={{ paddingTop: '8px' }}>
                    Note* : Free
                    23 days remaining in your trial.
                    When your trial ends, you will be billed $10 a month per clinician. </p>
                </div>
                <Button type='primary'>Get Subscription</Button>
              </div>
            </div>*/}
          </div>
        </div>
      </div>
    );
  }
}

export default PricingIndex;
